import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DataServiceService } from '../data-service.service';
import { RegistrationForm } from '../../components/connects/connects';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  errorMessages: string;

  private readonly tokenKey = 'token';
  private isAuthenticated = false;
  constructor(private readonly http: HttpClient) {}
  private readonly router = inject(Router);
  private readonly sharedData = inject(DataServiceService);
  login(user) {
    return this.http
      .post<{ accessToken: string }>('/api/auth/login', user)
      .subscribe({
        next: (data) => {
          this.isAuthenticated = true;
          this.sharedData.setAuthStatus(true);
          localStorage.setItem('token', data.accessToken);
          // set auth object in local storage
          localStorage.setItem('auth', JSON.stringify(data));

          this.router.navigate(['/admin']);
        },
        error: () => {
          this.errorMessages = 'Invalid Credentials';
        },
      });
  }
  register(user: RegistrationForm) {
    return this.http.post('/api/auth/user', user);
  }

  getUsers() {
    return this.http.get<RegistrationForm[]>('/api/auth/users');
  }
  getAuthToken(): string {
    return localStorage.getItem(this.tokenKey);
  }
  isAuthenticatedUser() {
    return !!this.getAuthToken();
  }
  logout() {
    this.isAuthenticated = false;
    localStorage.removeItem('token');
    localStorage.removeItem('auth');
    this.router.navigate(['/login']);
  }
}
